module.exports = __webpack_public_path__ + "static/media/ritratto.7f7cff9f.jpeg";